import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  return (
    <div className="text-center space-y-4 mb-8">
      <div className="flex flex-col items-center gap-3">
        <img src="/assets/images/90A19BF4-3446-4543-87E4-2148054C81C1-1768952058269.jpeg" alt="OfferSense Logo" className="w-16 h-16 md:w-20 md:h-20 object-contain" />
        <h1 className="text-2xl md:text-3xl font-bold">
          <span className="text-[#2C3E5F]">OfferSense</span>
          <span className="text-[#5DBFB3]">.Ai</span>
        </h1>
      </div>
      
      <div className="space-y-2">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">
          Join OfferSense
        </h2>
        <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
          Create your professional account to streamline offer management and deliver exceptional service to your clients
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-4 md:gap-6 pt-4">
        <FeatureBadge icon="Shield" text="Secure & Compliant" />
        <FeatureBadge icon="Zap" text="Fast Setup" />
        <FeatureBadge icon="Users" text="Agent-Focused" />
      </div>
    </div>
  );
};

const FeatureBadge = ({ icon, text }) => (
  <div className="flex items-center gap-2 px-4 py-2 bg-muted rounded-lg">
    <Icon name={icon} size={18} className="text-primary" />
    <span className="text-sm font-medium text-foreground">{text}</span>
  </div>
);

export default RegistrationHeader;